import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import { deleteUser, getUsers } from 'action/user'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'

const generateModalText = (user) => ({
  decide: {
    content: 'This action cannot be undone',
    title: `Are you sure you want to delete ${user.first_name} ${user.last_name}?`
  },
  outcome: {
    content: {
      error: 'Please try Again',
      success: `${user.first_name} ${user.last_name} has been successfully deleted`
    },
    title: {
      error: `There has been an issue deleting ${user.first_name} ${user.last_name}`,
      success: 'User deleted'
    }
  }
})

const DeleteUser = ({ deleteUser, user }) => {
  const handleSubmit = () => deleteUser(user.uuid)

  const { decide, outcome } = generateModalText(user)

  return (
    <a onClick={() => confirmModal(handleSubmit, decide, outcome)}>Delete User</a>
  )
}

DeleteUser.propTypes = {
  deleteUser: PropTypes.func,
  user: PropTypes.object
}

const mapDispatchToProps = (dispatch) => ({
  deleteUser: bindActionCreators(deleteUser, dispatch),
  getUsers: bindActionCreators(getUsers, dispatch)
})

export default connect(null, mapDispatchToProps)(DeleteUser)
